import styled from '@emotion/styled'

import ProductForm from '@src/components/product/form/ProductForm'

const ProductRegistrationPage = () => {
	return (
		<Block>
			<ProductForm>
				<ProductForm.SectionBlock title="상품명(앱에 노출되는 상품명)">
					<ProductForm.TitleForm />
				</ProductForm.SectionBlock>
				<ProductForm.SectionBlock title="옵션설정">
					<ProductForm.TypeForm />
				</ProductForm.SectionBlock>
				<ProductForm.NormalPriceForm />
				<ProductForm.VariantForm />
				<ProductForm.SkuTable />
				<ProductForm.PackageForm />
				<ProductForm.SectionBlock title="상품 상세 페이지">
					<ProductForm.BannerForm />
					<ProductForm.DescriptionForm />
				</ProductForm.SectionBlock>
				<ProductForm.SectionBlock title="챌린지 성공 기준 (ex. 14일간 8회 이상 성공 시, 환급)">
					<ProductForm.ChallengeForm />
					<ProductForm.SampleProofForm />
				</ProductForm.SectionBlock>
				<ProductForm.SubmitBtn />
			</ProductForm>
		</Block>
	)
}

const Block = styled.div`
	width: 100%;
	height: 100%;
	padding-left: 3rem;
	padding-right: 3rem;
	padding-bottom: 3rem;
	margin-left: 11rem;
	overflow-y: scroll;
`

export default ProductRegistrationPage
